import ActionManager from '../ActionManager';

import Update from './Update';
ActionManager.register(Update, ['stores:MainStore']);